export default __webpack_public_path__ + "static/media/personal6.a5522c17.jpeg";